// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'lib-flexible'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'


Vue.config.productionTip = false
import { Swipe, SwipeItem } from 'mint-ui';
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);

import { Toast } from 'mint-ui';
window.Toast = Toast;

import { Checklist } from 'mint-ui';

import md5 from "js-md5"//md5
Vue.prototype.$md5 = md5

Vue.component(Checklist.name, Checklist)
Vue.prototype.axios = axios;
  axios.defaults.baseURL = "http://o2o.linkcool.top"
axios.defaults.withCredentials = true//设置了该变量，Access-Control-Allow-Origin不能为*
            window.getParam = function() {
                    var paramList = window.location.search.replace("?", "").split("&")
                    var param = []
                    paramList.forEach(item => {
                        let obj = {}
                        let key = item.split("=")[0]
                        let value = item.split("=")[1]
                        obj = {
                            key: key,
                            value: value
                        }
                        param.push(obj)
                    })
                    window.superior = param[0].value;
                    return param[0].value
                }
            window.checkPhone = function(myphone){    //手机号判断
              var phone = myphone
              if(!(/^1[3456789]\d{9}$/.test(phone))){ 
                  Toast("手机号码有误，请重填");  
                  return false; 
              } 
              return true;
           }
           window.checkPass = function(myPass){
            var pass = myPass;
            if(pass.length<6){
              Toast("密码长度不能低于6位")
              return false;
            }else if(pass.length>18){
              Toast("密码长度不能大于18位")
              return false;
            }
            return true;
           }
           window.checkCode = function(myCode){
            if(myCode.length<=0){
              Toast("请输入验证码");
              return false;
            }
            return true;
           }
          
          
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js